let env = "live";
let envJson = require('./env/'+env+'.json');
module.exports = {
       baseUrl: envJson.baseUrl,
       imageUrl: envJson.imageUrl,
       editor: envJson.editor
}